import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import SucursalesSelector from './SucursalesSelector.jsx';

class SucursalesLink extends Component {
    OpenBranches() {
        $("#SucursalesSelector").modal();
    }

    render() {
        let data = this.props.data.GET_SUCURSAL;
        let errorSave = this.props.data.errorSave;
        if (data.find(x => x.Checked === true) !== undefined && errorSave) {
            errorSave = false;
        }
        return (
            data.length > 0 &&
            <div className="row top-separator-xs">
                <div className="col-md-3">
                    <label className="label-primary">Sucursales</label>
                    <br />
                    <GenericSimpleButton text="Seleccionar..." buttonType="button" buttonClass="btn btn-link no-padding" onClick={this.OpenBranches} />
                    {errorSave === true ? <label className="error">Por favor selecciona al menos una sucursal</label> : undefined}
                    <GenericModal
                        type={"WITH_COMPONENTS_SAVE_CANCEL_SM"}
                        className="modal fade-out" id="SucursalesSelector"
                        header="Sucursales"
                        component={
                            <SucursalesSelector
                                data={data}
                                edicion={this.props.data.edicion}
                                saveSelectedBranches={this.props.saveSelectedBranches}
                                cancelSelectedBranches={this.props.cancelSelectedBranches}
                            />}
                    />
                </div>
                <div className="col-md-12">
                    {this.props.data.ERROR_PRODUCT["seleccionoSucursal"] == false &&
                        <label className="error">Debe seleccionar al menos una sucursal.</label>}
                </div>
            </div>
        );
    }
};

export default SucursalesLink;